const isLocalhost = (): boolean => {
  return (
    typeof window !== 'undefined' &&
    window.location &&
    window.location.hostname === 'localhost'
  )
}

export default isLocalhost
